import React from 'react'

function HomeSection6() {
  return (
    <div className='hs1'>
    <span className='hs1-head'>TESTIMONIALS</span>
   <span className='hs1-title'>What our client say?</span>
    </div>
  )
}

export default HomeSection6
